<template>
    <nav
        class="navbar has-shadow is-fixed-top app-navbar"
        :class="isMobile?'small':'large'"
        role="navigation"
        aria-label="main navigation"
    >
        <div class="navbar-brand ml-3">
            <a href="https://www.eduloc360.com" target="_blank" class="navbar-item is-marginless">
                <img
                    src="@/assets/images/logo_eduloc360.png"
                    alt="eduloc360"
                    width="160"
                    height="50"
                />
            </a>
            <!--<a
                role="button"
                class="navbar-burger burger"
                aria-label="menu"
                aria-expanded="false"
                data-target="navbar"
                @click="menuActive = !menuActive"
            >
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
            </a>-->
        </div>

        <div
            id="navbar"
            class="navbar-menu"
        >
            <div class="navbar-start" :class="{'ml-6': !isMobile}">
                
            </div>

            <div class="navbar-end">
                
                <!--<div class="navbar-item has-dropdown is-hoverable" v-if="!isMobile">
                    <a class="navbar-link is-arrowless mr-4">
                    <span class="icon"><i class="mdi mdi-28px mdi-web"></i></span>
                    </a>

                    <div class="navbar-dropdown">
                        <a
                            v-for="locale in locales"
                            :key="locale"
                            @click="switchLocale(locale)"
                            class="navbar-item"
                        >
                            {{ locale | localePrint }}
                        </a>
                    
                    </div>
                </div>
                
                <div class="navbar-item columns" v-else>
                    <a
                            v-for="locale in locales"
                            :key="locale"
                            @click="switchLocale(locale)"
                            class="lang-menu-item column is-6-mobile"
                            :class="{'active':isLangActive(locale)}"
                        >
                            {{ locale | localePrint }}
                        </a>
                </div>-->
                
            </div>
        </div>
    </nav>
</template>

<script>
export default {
    components: {
    },
    props: {
        
    },
    data() {
        return {
            menuActive: false,
            locales: process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(','),
        };
    },
    filters: {
        localePrint(locale) {
            return locale.slice(0, 2).toUpperCase();
        },
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        location() {
            return location;
        },
        
        isMobile(){
            return this.$mq=="mobile"
        },
    },
    methods: {
        isLangActive(locale){
            return this.$i18n.locale == locale;
        },
        
        switchLocale(locale) {
            if (this.$i18n.locale !== locale) {
                this.$i18n.locale = locale;
            }
        },
    },
};
</script>

<style scoped>
@import '../assets/css/navbar.css';
.lb-app-navbar {
    z-index: 31 !important;
}
.app-navbar-embed.large .navbar-menu a, .app-navbar-embed.large .navbar-item{
    color: #ffffff;
}
.app-navbar-embed.large .navbar-dropdown .navbar-item{
    color: black;
}
.app-navbar-embed.small .navbar-menu a, .app-navbar-embed.small .navbar-item{
    color: #000000;
}
.app-navbar-embed.small .navbar-divider{
    display: block;
}
.app-navbar-embed.small .column{
    display: inline-block;
    text-align: center;
}
.app-navbar-embed.small .column.active{
    background-color: #f4f4f4;
}
.app-navbar-embed.small .columns{
    margin: 0;
}
</style>
